import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import { useGetOrdersMutation } from "../../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../../features/auth/authSlice";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import ViewOrdersModal from "../../models/ViewOrdersModal";

const Index = () => {
  const [getOrdersAPI] = useGetOrdersMutation();
  const sponserId = useSelector(selectSponserID);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([] as any);
  const [openModal, setOpenModal] = useState({
    showModal: false,
    products: [],
  });

  useEffect(() => {
    const getOrders = async () => {
      const response: any = await getOrdersAPI({ sponserId }).unwrap();
      if (response.status === 200) {
        setData(response.orders);
      }
    };
    getOrders();
  }, [getOrdersAPI, sponserId]);

  const columns = [
    { field: "_id", headerName: "ID", width: 190 },
    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 190,
    },
    {
      field: "landingPageId",
      headerName: "Landingpage ID",
      width: 200,
    },
    {
      field: "address1",
      headerName: "Address 1",
      width: 200,
    },
    {
      field: "address2",
      headerName: "Address 2",
      width: 200,
    },
    {
      field: "PINCode",
      headerName: "PIN Code",
      width: 200,
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      width: 200,
    },
  ];

  const handleEvent = (
    params: any, // GridRowParams
    event: any, // MuiEvent<React.MouseEvent<HTMLElement>>
    details: any // GridCallbackDetails
  ) => {
    setOpenModal({ showModal: true, products: params.row.products });
  };

  return (
    <div className="mt-[100px] ml-5">
      <Header title="Orders" subtitle="Orders Lists" />
      <Box
        m={"40px 0 0 0"}
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "noone",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          components={{ Toolbar: GridToolbar }}
          rows={data}
          /*@ts-ignore */
          columns={columns}
          autoHeight={true}
          getRowId={(row) => row._id}
          onRowClick={handleEvent}
        />
        {openModal.showModal && (
          <ViewOrdersModal
            setOpenModal={setOpenModal}
            data={openModal.products}
          />
        )}
      </Box>
    </div>
  );
};

export default Index;
